import {Component, Input, OnInit} from '@angular/core';
import {Chart} from "../../lbarometer/shared/shared.interface";

@Component({
  selector: 'app-chart-comp-selection-wrapper',
  templateUrl: './chart-comp-selection-wrapper.component.html',
  styleUrls: ['./chart-comp-selection-wrapper.component.scss']
})
export class ChartCompSelectionWrapperComponent implements OnInit {
  @Input() chartType: string = 'rdna';
  @Input() chartData: any;
  @Input() savedChartListId: number | null = null;

  showdata: boolean = true;
  customTextElements: any | null = null;

  ngOnInit() {
    if (this.chartType === 'lb') {
      this.chartData = this.chartData.visualization[0]
      this.customTextElements = this.chartData.custom_text_elements;
    }

  }
}
